// extracted by mini-css-extract-plugin
export default {"Header":"bomPdfHeader-module_Header_mtdvB","HeaderContent":"bomPdfHeader-module_HeaderContent__7ZL9","Separator":"bomPdfHeader-module_Separator_Gz0N1"};